import { saga as sagaAuth } from './saga.auth';

export const allSagas = {
  'sloyd.auth': sagaAuth,
};
